import React from 'react'
import { Switch } from '@mui/material'
import { Add, Remove } from '@mui/icons-material'

const MinesPopUp = () => {
  return (
    <div className='minesPopup z-50 bg-[#2c2d30] rounded-lg px-4 py-2'>
        <div className='flex justify-between items-center bg-[#2c2d30] p-2'>
            <div className='flex justify-center items-center space-x-2'>
                <p className='text-white'>AUTO PLAY</p>
            </div>
       </div>
       <div className='flex flex-col bg-[#1b1c1d] my-4 justify-center items-center rounded-lg px-2 py-1'>
           <p className='text-sm text-white'>Number of rounds</p>
           <div className='grid grid-cols-2 gap-2 my-1 w-full'>
            <div className='flex bg-gray-500 space-x-10 rounded-lg items-center p-2'>
                <div className='w-[10px] h-[10px] rounded-full bg-green-600'/>
                <p className='text-white text-sm'>3</p>
            </div>
            <div className='flex bg-gray-700 space-x-10 rounded-lg items-center p-2'>
                <div className='w-[10px] h-[10px] rounded-full bg-gray-400'/>
                <p className='text-white text-sm'>10</p>
            </div>
            <div className='flex bg-gray-700 space-x-10 rounded-lg items-center p-2'>
                <div className='w-[10px] h-[10px] rounded-full bg-gray-400'/>
                <p className='text-white text-sm'>10</p>
            </div>
            <div className='flex bg-gray-700 space-x-10 rounded-lg items-center p-2'>
                <div className='w-[10px] h-[10px] rounded-full bg-gray-400'/>
                <p className='text-white text-sm'>10</p>
            </div>
            <div className='flex bg-gray-700 space-x-10 rounded-lg items-center p-2'>
                <div className='w-[10px] h-[10px] rounded-full bg-gray-400'/>
                <p className='text-white text-sm'>10</p>
            </div>
            <div className='flex bg-gray-700 space-x-10 rounded-lg items-center p-2'>
                <div className='w-[10px] h-[10px] rounded-full bg-gray-400'/>
                <p className='text-white text-sm'>10</p>
            </div>
           </div>
       </div>

        <div className='flex flex-col space-y-4'>
            <div className='bg-[#4d4f50] rounded-lg flex justify-between items-center px-2 py-1'>
                <div className='flex  justfy-center items-center'>

                <Switch
                sx={{
                    '& .MuiSwitch-switchBase.Mui-checked': {
                    color: '#efefef', // Thumb color when checked
                    },
                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                    backgroundColor: '#2fff00', // Track color when checked
                    },
                    '& .MuiSwitch-track': {
                    backgroundColor: 'gray', // Default track color
                    },'& .MuiSwitch-thumb': {
                        width: 19, // Keep the thumb size same
                        height: 19,
                      },"& .MuiSwitch-track": {
                        border: "1px solid #8d8e8e", // Border for track
                      },
                }}
                />
                    <p className='text-[0.8rem] text-white'>Stop if cash decreases by</p>
                </div>

                <div className='flex justify-between items-center bg-[#141516] rounded-full p-1 px-1 space-x-2 text-white font-semibold'>
                    <p  className='cursor-pointer rounded-full w-[22px] h-[22px] border-2 border-[#5a5e66] text-[#5a5e66] text-center flex justify-center items-center  font-bold'><Remove fontSize='small'/></p>
                    <p className='px-1 '>0.00</p>
                    <p className='text-sm cursor-pointer rounded-full w-[22px] h-[22px] border-2 border-[#5a5e66] text-[#5a5e66] text-center flex justify-center items-center  font-bold'><Add fontSize='small'/></p>
                </div>
             </div>
             <div className='bg-[#4d4f50] rounded-lg flex justify-between items-center p-1'>
                <div className='flex  justfy-center items-center'>

                <Switch
                sx={{
                    '& .MuiSwitch-switchBase.Mui-checked': {
                    color: '#efefef', // Thumb color when checked
                    },
                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                    backgroundColor: '#2fff00', // Track color when checked
                    },
                    '& .MuiSwitch-track': {
                    backgroundColor: 'gray', // Default track color
                    },'& .MuiSwitch-thumb': {
                        width: 19, // Keep the thumb size same
                        height: 19,
                      },"& .MuiSwitch-track": {
                        border: "1px solid #8d8e8e", // Border for track
                      },
                }}
                />
                    <p className='text-[0.8rem] text-white'>Stop if single win exceeds</p>
                </div>

                <div className='flex justify-between items-center bg-[#141516] rounded-full p-1 px-1 space-x-2 text-white font-semibold'>
                    <p  className='cursor-pointer rounded-full w-[22px] h-[22px] border-2 border-[#5a5e66] text-[#5a5e66] text-center flex justify-center items-center  font-bold'><Remove fontSize='small'/></p>
                    <p className='px-1 '>0.00</p>
                    <p className='text-sm cursor-pointer rounded-full w-[22px] h-[22px] border-2 border-[#5a5e66] text-[#5a5e66] text-center flex justify-center items-center  font-bold'><Add fontSize='small'/></p>
                </div>
             </div>
        </div>      
        <button  className={`cursor-pointer w-full flex justify-center items-center minesbtn space-x-[4.2rem] rounded-2xl mt-8  p-[0.6rem] shadow-black shadow-md border-2 border-[#000]`}>
            
            <p className="text-white">START AUTO</p>
        </button>
    </div>
  )
}

export default MinesPopUp